import { atom, atomFamily, selector } from 'recoil';
import type { UserResourceObject } from '@dmp/feedr/data-access';

type UserAttributes = UserResourceObject['attributes'];

export interface UserState extends UserAttributes {
    id: UserResourceObject['id'];
}

export const currentUserIdState = atom<UserState['id'] | undefined>({
    key: 'currentUserIdState',
    default: undefined,
});

/**
 * User item state by id
 *
 * @param CardId
 */
export const userItemState = atomFamily<UserState | undefined, UserState['id']>(
    {
        key: 'userItemState',
        default: undefined,
    }
);

export const currentUserSelector = selector({
    key: 'currentUser',
    get: ({ get }) => {
        const currentUserId = get(currentUserIdState);

        if (!currentUserId) {
            return undefined;
        }

        return get(userItemState(currentUserId));
    },
});
